<template>
    <ul class="list-inline categories-slider">
        <li class="list-inline-item"
            v-for="category in subCategories">
            <a :href="concatPath(category)"
               class="badge-cat">
                {{category.category_name}}
            </a>
        </li>
    </ul>
</template>

<script>
import { PAGES } from '@/utils';
import API from '@/api/index';
import {  mapState, } from "vuex";

export default {
    name: "CategoriesCarousel",
    props: {
        parentId: {
            type: Number
        }
    },
    /**data() {
        return {
            categories: []
        }
    },**/
    computed: {
        ...mapState(['categories']),
        categoryType() {
            return Object.keys(this.categories).filter(ct=>this.categories[ct].filter(c=>c.id_parent_category === null && c.search_field === this.$route.params.category).length)[0];
        },
        subCategories() {
            return _.filter(this.categories[this.categoryType], {id_parent_category: this.parentId});
        },
    },
    methods: {
        concatPath(category) {
            return PAGES.LIST + '#' + this.getCategoryPath(category);
        },
        parentCategory(id) {
            return _.find(this.categories[this.categoryType], {id_category: id});
        },
        getCategoryPath(category) {
            if (category.id_parent_category && this.parentCategory(category.id_parent_category)) {
                return this.getCategoryPath(this.parentCategory(category.id_parent_category)) + '/' + category.search_field; //_.snakeCase(category.category_name);
            } else {
                return '/' + category.search_field; //_.snakeCase(category.category_name);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            $(this.$el).slick({
                infinite: false,
                slidesToShow: 9,
                slidesToScroll: 2,
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">\n' +
                    '    <i class="icon-left"></i>\n' +
                    '</button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button">\n' +
                    '    <i class="icon-right"></i>\n' +
                    '</button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 9,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        });
    },

}
</script>

<style>
    .categories-slider .slick-next,
    .categories-slider .slick-prev {
        top: 0;
    }
</style>

<style scoped>
    .slick-slider .slick-list .slick-track {
        width:max-content !important;
    }
    li.list-inline-item.slick-slide {
    	width: fit-content !important;
    }
    .list-inline-item {
        padding-right: 20px;
    }

    .badge {
        border: 1px solid #ababab;
        color: #ababab !important;
        background-color: white !important;
        font-family: "Source Sans Pro";
        font-size: 18px;
        line-height: 22px;

        font-weight: normal;

        border-radius: 20px;

        padding-top: 7px;
        padding-bottom: 7px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .categories-slider /deep/ .slick-prev:before,
    .categories-slider /deep/ .slick-next:before {
        content: '';
    }
</style>
